import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const sailPoint = defineConnector({
  identifier: "sailPoint",
  name: "SailPoint",
  tagLine: "Identity security platform",
  logo,
  protocol: "http",
  tags: ["security", "identity", "it"],
  defaultUrlPattern: () => "https://[^/]*\\.api\\.identitynow\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your SailPoint IdentityNow tenant, navigate to **Preferences > Personal Access Tokens**, and create a new token.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Tenant",
          required: true,
          placeholder: "your-tenant",
          helperText:
            "Your SailPoint tenant name (e.g., your-tenant from your-tenant.api.identitynow.com).",
          target: { kind: "configuration", field: "tenant" },
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          placeholder: "Your Client ID",
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          placeholder: "Your Client Secret",
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ tenant }) => `https://${tenant}/oauth/token`,
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: ({ tenant }) => `https://${tenant}/v3/public-identities-config`,
  },
  publicEnvVars: ({ tenant }) => ({
    SAIL_POINT_URL: tenant ? `https://${tenant}` : "",
  }),
});
